import React from "react";
import { Button, Grid, Modal as MuiModal, Typography } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers/icons";

interface Props {
  showModal: boolean;
  closeModal: () => void;
  handleOnClick: () => void;
  isActive: boolean;
}

const ActivateDeactivateProviderModal: React.FC<Props> = ({
  showModal,
  closeModal,
  handleOnClick,
  isActive,
}) => {
  return (
    <MuiModal open={showModal} className="modal-primary">
      <div className="paper" style={{ width: 430 }}>
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <div className="main-header" style={{ marginBottom: "20px" }}>
                <span>
                  {isActive ? "Deactivate Provider" : "Reinstate Provider"}
                </span>
                <span id="dismiss-button" onClick={closeModal}>
                  <ClearIcon sx={{ width: 30, height: 30 }} />
                </span>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                paddingLeft: "24px",
                paddingRight: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "#1E1E1E",
                  textAlign: "center",
                }}
              >
                {isActive
                  ? "You are attempting to deactivate this user. Would you like to continue?"
                  : "This provider was previously deactivated. Would you like to reinstate their account?"}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="modal-footer"
          >
            <Grid item xs={12} className="confirm-btn-container">
              <div onClick={closeModal} className="cancel-link">
                Cancel
              </div>
              <Button
                onClick={handleOnClick}
                className="confirm-btn"
                style={{ width: 156 }}
              >
                {isActive ? "Deactivate" : "Reinstate"}
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </MuiModal>
  );
};

export default ActivateDeactivateProviderModal;
